import { render } from "./addon.view.vue?vue&type=template&id=03523731&scoped=true&ts=true"
import script from "./addon.view.vue?vue&type=script&lang=ts"
export * from "./addon.view.vue?vue&type=script&lang=ts"

import "./addon.view.vue?vue&type=style&index=0&id=03523731&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03523731"]])

export default __exports__